module.exports = __webpack_public_path__ + "static/event6-9be5577db606361776363de9c0b6081c.jpg";